import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=f1edccc4&scoped=true"
import script from "./orderList.vue?vue&type=script&lang=js"
export * from "./orderList.vue?vue&type=script&lang=js"
import style0 from "./orderList.vue?vue&type=style&index=0&id=f1edccc4&prod&lang=scss"
import style1 from "./orderList.vue?vue&type=style&index=1&id=f1edccc4&prod&lang=scss&scoped=true"
import style2 from "./orderList.vue?vue&type=style&index=2&id=f1edccc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1edccc4",
  null
  
)

export default component.exports